// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"68dc6773bc","253":"611c280446","619":"dd1db5d6b1"}[chunkId] + ".js";
};